import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import fr from 'facet-rest';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

const FacetPlanChooseStartEndDateStepLayout = ({
  className,
  classes,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <TitleSection />
      <MetaField attr="startDate" />
      <MetaField attr="endDate" disabled={resource.attr('useOutcomeEndDate') === 'true'} />
      <MetaField attr="useOutcomeEndDate" />
      {/* <MetaField disabled={resource.attr('endAtRetirement') === 'true'} attr="endDate" /> */}
      {/* <MetaField attr="endAtRetirement" /> */}
      {/* <MetaField disabled={resource.attr('endAtRetirement') !== 'true'} hidden={resource.attr('endAtRetirement') !== 'true'} attr="retiringClient" /> */}
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={() => {
          onSubmit();
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanChooseStartEndDateStepLayout.defaultProps = {
  className: '',
};

FacetPlanChooseStartEndDateStepLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanChooseStartEndDateStepLayout);
